import { getAllSpeciesAtLocation } from '../../../api/fishrules/getAllSpeciesAtLocation';
import { ICoordinates } from '@app-types/geo';
import { formatAllSpeciesData, FormattedSpecies } from '@domain/regulations/formatAllSpeciesData';
import { filterSpeciesByIds } from '@domain/regulations/filterAllSpeciesByIds';
import { useAsyncQuery } from '@hooks/useAsyncQuery';

interface Result {
  isLoading: boolean;
  allSpecies: FormattedSpecies[];
}

export function useAllSpeciesAtLocation(
  coordinates?: ICoordinates,
  speciesIdsFilter?: string[],
): Result {
  const latitude = coordinates?.latitude;
  const longitude = coordinates?.longitude;
  const key =
    latitude && longitude ? `${latitude},${longitude}:${JSON.stringify(speciesIdsFilter)}` : null;

  const { isLoading, data } = useAsyncQuery(key, async signal => {
    const results = await getAllSpeciesAtLocation(coordinates!, signal);
    // Better to filter in fishrules API directly, but for now we filter here
    return formatAllSpeciesData(
      results.filter(species => filterSpeciesByIds(species, speciesIdsFilter)),
    );
  });

  // Waiting for coordinates counts as loading, so the Explore drawer keeps its spinner until the
  // map location exists.
  return { isLoading: key === null || isLoading, allSpecies: data ?? [] };
}
